export default class UserDeniedPermission extends Error {
  constructor() {
    super(
      "IdP denied access. This usually happens when user refuses to grant permission."
    );
  }
}
